/****************************************************************************************
 * File Name    : App.vue
 * Function     :
 * Author       : 최명호
 * Tester       :
 * Page         :
 * Target       :
 * Description  :
 * Modification Log
 * ======================================================================================
 * Ver  Date        	Author     	Modification
 * ======================================================================================
   1.0  2021.06.26  	최명호    	Create
****************************************************************************************/
<template>

    <div id="app">
        <!--  -->
        <a-layout id="components-layout-top-side">
            <a-layout-header v-if="$route.fullPath !== '/'" class="header" style="background-color:#fff !important;">
                <a-row :gutter="16">
                    <a-col :span="6" style="line-height:50px;">
                        <div class="logo" >         
                        </div>
                        <span style="float:left; margin-right:15px; color:#0099DC; font-weight:bold; font-size:20px;">Coway</span>
                        <span class="site-name top-header-title" v-if="headerTitles[headerSelectedIndex] === 'Home'" style="margin-top:2px; font-weight:bold; font-size:22px; color:#111F48;">Dashboard</span>
                        <span class="site-name top-header-title" v-if="headerTitles[headerSelectedIndex] !== 'Home'" v-text="headerTitles[headerSelectedIndex]" style="margin-top:2px; font-weight:bold; font-size:22px; color:#111F48;"></span>
                    </a-col>
                    <a-col :span="18">
                        <a-row :gutter="16">
                            <a-col :span="24">
                                <a-menu theme="light" mode="horizontal" :default-selected-keys="[0]" :style="{ lineHeight: '50px', textAlign: 'right', marginRight: '200px', fontWeight: 'bold', fontSize: '16px', border: 'none' }" @click="headerMenuClick">
                                    <!-- Home 메뉴 제외한 나머지 메뉴 출력 -->
                                    <a-menu-item v-for="(headerTitle,headerIndex) in headerTitles" :key='headerIndex' v-bind:style= "headerIndex === 9 ? 'margin-left:15%' : ''">
                                        <span class="title">{{headerTitle}}</span>
                                    </a-menu-item>
                                </a-menu>
                            </a-col>
                        </a-row>
                    </a-col>
                </a-row>
            </a-layout-header>

            <a-layout-content style="position:relative; padding: 0px 50px">
                <a-button v-if="$route.fullPath !== '/'" style="position:absolute; top:-40px; right:65px; border:none; z-index:10;" @click="logout()" type="default" html-type="button" :ghost = false size = "small"><img src="./assets/images/btn-logout.png" /></a-button>
                <a-divider type = 'horizontal' />
                <a-layout style="padding: 0px 0; background: #fff">
                    <a-layout-sider v-if="!$route.fullPath.match('dashboard')" width="250" style="background: #fff">
                        <!-- <router-link to="/">COWAY</router-link> -->
                        <a-menu mode="inline" :default-selected-keys="[headerSelectedIndex + ',' + subSelected[headerSelectedIndex]]" :default-open-keys="[]" style="height: 100%" :key="headerSelectedIndex">
                        <!--a-menu mode="inline"  :default-open-keys="[]" style="height: 100%" -->

                            <a-menu-item v-for="(title,index) in titles[headerSelectedIndex]" :key= "+headerSelectedIndex + ',' + index" class="desktop-only" @click="menuClick" >
                                <router-link :to="routers[headerSelectedIndex][index]"            >
                                    <a-icon :type='icons[headerSelectedIndex][index]'></a-icon>
                                    {{ title }}                
                                </router-link>
                            </a-menu-item>
                        </a-menu>
                    </a-layout-sider>
                    <a-layout-content :style="{ padding: '0 24px', minHeight: '280px' }">
                        <router-view :key="$route.fullPath" />
                    </a-layout-content>
                </a-layout>
            </a-layout-content>
        </a-layout>
  </div>
</template>
<script>
import _ from "lodash";

export default {
    name: 'App',
    components: {
    },
    computed: {
        currentRouteName() {
            let routeName = this.$route.name
            if (routeName === 'Home') { // 로그인시
                routeName = 'Dashboard';
            }

            return routeName;
        },
        currentRoutePath() {
            return this.$route.path;
        }
    },
    data() {
        return {
            headerTitles: ['Home','초/중/종품','공정순회','치공구외','안전보건','필터','4M 관리','중점관리','시스템',''],  // 맨 끝은 사용자이름 표시 부분
            routers:[['/dashboard'],['/finished','/sheetFinished','/finishedReport','/finishedHistoryCreate','/finishedHistoryList'],['/patrol','/sheetPatrol','/patrolReport'],['/toolTemplateRegister','/toolWorkSheet','/toolWorkReport'],['/safety','/sheetSafety','/safetyReport'],['/filter','/sheetFilter','/filterReport','/filterProcessRegister','/filterProcessWorkSheet','/filterProcessWorkReport','/filterWorkRegister','/filterWorkSheet','/filterWorkReport'],['/patrol4mCreate','/patrol4mList'],['/errorCreate','/errorList'],['/factory','/account','/managerAdmin','/product','/safetyContentEditor','/deleteCSImage']],
            titles:[['대시보드 관리'],['검사 성적서 등록','검사 현황','보고서 관리','',''],['체크시트 등록','검사 현황','보고서 관리'],['신규등록','일지작성','일지관리'],['점검일지 등록','작성현황','점검일지 관리'],['검사 성적서 등록','검사 현황','성적서 관리','공정점검-신규등록','공정점검-일지작성','공정점검-일지관리','작업일지-신규등록','작업일지-일지작성','작업일지-일지관리'],['등록하기','등록현황'],['중점관리 등록','중점관리 현황'],['공장','사용자 계정 관리','관리자 관리','제품 등록','안전보건 준수사항 관리','이미지 삭제']],
            icons:[['dashboard'],['exception','profile','setting','',''],['exception','profile','setting'],['plus-circle','edit','setting'],['exception','profile','setting'],['exception','profile','setting','plus-circle','edit','setting','plus-circle','edit','setting'],['profile','setting'],['profile','setting'],['bank','usergroup-add','team','plus-circle','edit','delete']],
            headerSelectedIndex: 0,
            subSelected:[0,0,0,0,0,0,0,0,0],

            userName: '',
            userNumber: '',
            userKind: '',
        };
    },
    mounted() {
        // console.log(this.currentRouteName)
        // this.$router.push(this.routers[0][0])
        this.menuHighlight(this.currentRoutePath);
        this.handleRoute();
    },
    methods : {
        headerMenuClick(e) {
            console.log(e);
            // 상단 메뉴 클릭시 이전에 클릭했던 소메뉴로 이동
            /*
            // if(this.headerSelectedIndex != e.key){
                this.$router.push(this.routers[e.key][this.subSelected[e.key]])
            // }
            this.headerSelectedIndex = e.key;
            //this.$router.push('/product');
            */
            console.log('headermenu', e)
            // 상단 메뉴 클릭시 메뉴의 첫번째 소메뉴로 이동
            this.$router.push(this.routers[e.key][this.subSelected[0]]);
            // this.headerSelectedIndex = 0;
        },
        menuClick(e){
            console.log('menuClick:',e);
            const list = e.key.split(',');console.log('submenu', e, list);
            console.log('list[1]:',list[1]);
            
            this.subSelected[this.headerSelectedIndex] = list[1];

        },
        test() {
            this.$store.commit('setFlagForDemo',false);
        },
        logout() {
            sessionStorage.removeItem('user_number');
            sessionStorage.removeItem('user_name');
            sessionStorage.removeItem('user_kind');

            // this.$router.push('/');
            location = '/';

            //'' + headerSelectedIndex + ',' + subSelected[headerSelectedIndex]
        },
        menuHighlight(toPath) {   // 상단, 좌측 메뉴 selected 적용
            let self = this;
            
            let headerMenuIndex = 0;
            let leftMenuIndex = 0;
    
            // routers 에 없는 메뉴에 대한 처리
            if (toPath === '/finishedProduct') {
                toPath = '/finished';
            } else if (toPath === '/patrolProduct') {
                toPath = '/patrol';
            } else if (toPath === '/patrol4mView') {
                toPath = '/patrol4mList';
            } else if (toPath === '/safetyProduct') {
                toPath = '/safety';
            } else if (toPath === '/filterProduct') {
                toPath = '/filter';
            } else if (toPath.match('/finishedHistory')) {
                toPath = '/finished';
            } else if (toPath.match('/patrolHistory')) {
                toPath = '/patrol';
            } else if (toPath.match('/safetyHistory')) {
                toPath = '/safety';
            } else if (toPath.match('/errorCreate')) {
                toPath = '/errorCreate';
            }

            // 상단 메뉴 적용
            let headerMenu = self.$el.querySelector('.ant-menu-horizontal') && self.$el.querySelector('.ant-menu-horizontal').querySelectorAll('.ant-menu-item');
            if (headerMenu) {
                headerMenu.forEach((item) => {
                    item.classList.remove('ant-menu-item-selected');
                });

                _.forEach(self.routers, (item, i) => {
                    if (item.indexOf(toPath) > -1) {
                        headerMenuIndex = i;
                    }
                });
                headerMenu[headerMenuIndex].classList.add('ant-menu-item-selected');

                self.headerSelectedIndex = headerMenuIndex;
            }

            // 좌측 메뉴 적용
            setTimeout(function() {
                let leftMenu = self.$el.querySelector('.ant-menu-inline') && self.$el.querySelector('.ant-menu-inline').querySelectorAll('.ant-menu-item');
                if (leftMenu) {
                    leftMenu.forEach((item) => {
                        item.classList.remove('ant-menu-item-selected');
                    });

                    _.forEach(self.routers[headerMenuIndex], (item, i) => {
                        if (item === toPath) {
                            leftMenuIndex = i;
                        }
                    });
                    
                    if (leftMenu[leftMenuIndex].querySelector('a').innerText) { // 메뉴명이 있을때에만 선택된 메뉴로 적용
                        leftMenu[leftMenuIndex].classList.add('ant-menu-item-selected');
                    }
                }

                let topHeaderTitle = self.$el.querySelector('.top-header-title');
                if (topHeaderTitle) {
                    topHeaderTitle.innerHTML = '<span style="margin-left:-10px; margin-right:5px; color:#0099DC">유구공장</span> ' + self.headerTitles[headerMenuIndex];
                }
            }, 0);
        },
        handleRoute(to, from) {
            this.userName = sessionStorage.getItem('user_name');
            this.userNumber = sessionStorage.getItem('user_number');
            this.userKind = sessionStorage.getItem('user_kind');

            if (to && from) {
                console.log(to);
                console.log(from);

                // 로그인 안된 상태
                if (to.path !== '/' && !this.userNumber) {
                    this.$router.push('/');
                }

                // 로그인 상태
                if (this.userName) {
                    // 상단 메뉴 제일 우측 "사용자이름"을 로그인 사용자 이름으로 변경
                    setTimeout(() => {
                        this.$el.querySelectorAll('.ant-menu.ant-menu-horizontal.ant-menu-root li')[17].querySelector('.title').innerHTML = this.userName;
                    }, 200);
                }

                // 상단, 좌측 메뉴 selected 적용
                this.menuHighlight(to.path);
            }
            // 최초 접속 또는 새로고침 하는 경우
            else {
                // 로그인 안된 상태
                if (!this.userNumber) {
                    this.$router.push('/');
                }

                // 로그인 상태
                if (this.userName) {
                    // 상단 메뉴 제일 우측 "사용자이름"을 로그인 사용자 이름으로 변경
                    setTimeout(() => {
                        this.$el.querySelectorAll('.ant-menu.ant-menu-horizontal.ant-menu-root li')[17].querySelector('.title').innerHTML = this.userName;
                    }, 200);
                }
            }
        }
    },
    watch:{
        $route (to, from){
            this.handleRoute(to, from);
        }
    }
}
</script>
<style>
    html {
        overflow-y: scroll; /* 스크롤바를 항상 표시하여 레이아웃 shift 방지 */
    }
    #app {
    font-family : Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing : antialiased;
    -moz-osx-font-smoothing : grayscale;
    text-align : left;
    color : #2c3e50;
    }
    .ant-layout-header {
        height: 50px !important;
        padding: 0 50px;
        line-height: 40px;
        background: #FFF;
    }
    .ant-layout {
        background: #FFF !important;
    }
    .ant-layout-header {
        background: #FFF !important;
    }
    .ant-divider-horizontal {
        margin: 10px 0 !important;
    }
    .header {
        /* font-size : 20px; */
    }
    .icon_button {
        cursor : pointer;
    }
    .div_action {
        width : 100%;
        text-align: right;
        padding-bottom: 10px;
        /* margin-top:15px; */
    }
    .ant-form-item  {
        margin-bottom: 5px !important;
    }
    .ant-form-item-label  {
        font-weight: 700  !important;
    }
    .todo {
        display: none;
        color:#9B0000;
        font-weight : 700;
        margin : 0px 0px 10px 0px;
        text-decoration: underline;
    }

    /* 바코드 스캐너 */
    #qr-reader__dashboard_section_swaplink {
        display: none !important;
    }

    /* 태블릿 */
    @media (max-width: 1280px) {
        .ant-layout-header,
        .ant-breadcrumb,
        .ant-divider-horizontal,
        .desktop-only,
        .ant-layout-sider {
            display: none !important;
        }
    }

    #components-layout-top-side
    .logo{
        display: none;
        width: 30px;
        height: 31px;
        background: rgba(255, 255, 255, 0.2);
        margin: 16px 28px 16px 0;
        float: left;

    }
    .site-name{
        height: 31px;
        margin: 16px 28px 16px 0;
        float: left;
    }

    .top-menu-icon {
        width: 30px;
    }
</style>